<template>
  <div class="outDiv">
    <div class="gather animated fadeInUp">
      <Player></Player>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    Player: () => import('@/components/Player.vue')
  },
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped></style>
